import cabine from '../../../services/cabineApi';
import { gotErrorFromApi, gotErrorFromApiData } from '../../../utils/api';
import store from '../../configureStore';
import {
  eraserList,
  getErrorList,
  getListOfClientsAndBalances,
  getListOfPartners,
  loadingClientsList,
} from '../../duck/legado/clientsApp';
import {
  getCustomersDocumentsFromApi,
  getDocumentsListFromApi,
  gotCustomersDocumentsFromApi,
  gotDocumentsListFromApi,
} from '../../duck/legado/clientsApp/customersDocuments';
import {
  setAccountFilterOptions,
  setFinalDateFilterOptions,
  setInitialDateFilterOptions,
  setOwnershipFilterOptions,
  setPartnerFilterOptions,
  setStatusFilterOptions,
  settingFilter,
} from '../../duck/legado/clientsApp/filter';
import {
  getSingleClient,
  resetApiBalanceAction,
} from '../../duck/legado/clientsApp/single';
import { SendLoginTokenAuth } from '../tokens';
import { IBalance } from './interfaces/IBalance';

export function getClients(
  partnerId: number | string,
  typeId: number | string,
  initialDate?: string,
  finalDate?: string,
  ownership?: number | string,
  status?: string | number
) {
  store.dispatch(loadingClientsList());
  switch (ownership) {
    case '1':
      return (dispatch: any) => {
        cabine
          .get(
            `/v1/legado/clientes/cabine/fiducia/${typeId}/${initialDate}/${finalDate}?status=${status}`,
            SendLoginTokenAuth()
          )
          .then((response: any) => {
            response.data.data_de_pesquisa = {
              de: initialDate,
              ate: finalDate,
            };
            dispatch(getListOfClientsAndBalances(response.data));
          })
          .catch((error: any) => {
            gotErrorFromApi(error, dispatch, eraserList);
          });
      };

    case '2':
      return (dispatch: any) => {
        cabine
          .get(
            `/v1/legado/clientes/cabine/terceiro/${typeId}/${initialDate}/${finalDate}?status=${status}`,
            SendLoginTokenAuth()
          )
          .then((response: any) => {
            response.data.data_de_pesquisa = {
              de: initialDate,
              ate: finalDate,
            };
            dispatch(getListOfClientsAndBalances(response.data));
          })
          .catch((error: any) => {
            gotErrorFromApi(error, dispatch, eraserList);
          });
      };

    default:
      return (dispatch: any) => {
        cabine
          .get(
            `/v1/legado/clientes/cabine/${partnerId}/${typeId}/${initialDate}/${finalDate}?status=${status}`,
            SendLoginTokenAuth()
          )
          .then((response: any) => {
            response.data.data_de_pesquisa = {
              de: initialDate,
              ate: finalDate,
            };
            dispatch(getListOfClientsAndBalances(response.data));
          })
          .catch((error: any) => {
            gotErrorFromApi(error, dispatch, eraserList);
          });
      };
  }
}

export function getClientsBalance(
  partnerId: number | string,
  typeId: number | string,
  initialDate?: string,
  status?: string | number,
  finalDate?: string
) {
  store.dispatch(loadingClientsList());
  return (dispatch: any) => {
    cabine
      .get(
        `/v1/legado/clientes/cabine/sem-saldo/${partnerId}/${typeId}?status=${status}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.data_de_pesquisa = {
          de: initialDate,
          ate: finalDate,
        };
        dispatch(getListOfClientsAndBalances(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserList);
      });
  };
}

export function getOneClient(idParceiroLegado: number, reference: string) {
  store.dispatch(loadingClientsList());

  return (dispatch: any) => {
    cabine
      .get(
        `/v1/legado/clientes/cabine/${idParceiroLegado}/${reference}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        const dataClient: IBalance = {
          clientes: response.data.clientes,
          data_de_pesquisa: {
            de: new Date().toISOString(),
            ate: new Date().toISOString(),
          },
          saldoTotal: response.data.saldoTotal,
        };

        dispatch(getListOfClientsAndBalances(dataClient));
      })
      .catch((error) => {
        gotErrorFromApiData(error.response.data, dispatch, getErrorList);
      });
  };
}

export function getApiBalance(
  agency: any,
  account: any,
  digit: any,
  cpfCnpj: any
) {
  return (dispatch: any) => {
    cabine
      .get(
        `/v1/legado/consulta/saldo/${agency}/${account}/${digit}/${cpfCnpj}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(getSingleClient(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserList);
      });
  };
}

export function resetApiBalance() {
  return (dispatch: any) => {
    dispatch(resetApiBalanceAction());
  };
}

export function getAllPartnersList() {
  return (dispatch: any) => {
    cabine
      .get('/v1/legado/parceiros', SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(getListOfPartners(response.data.parceiros));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserList);
      });
  };
}

export function actionLoadingClientList() {
  return (dispatch: any) => {
    dispatch(loadingClientsList());
  };
}

export function setPartnerOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setPartnerFilterOptions(props));
  };
}

export function setOwnershipOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setOwnershipFilterOptions(props));
  };
}

export function setStatusOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setStatusFilterOptions(props));
  };
}

export function setAccountOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setAccountFilterOptions(props));
  };
}

export function setInitialDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setInitialDateFilterOptions(props));
  };
}

export function setFinalDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFinalDateFilterOptions(props));
  };
}

export function getClientDocuments(
  agency: any,
  account: any,
  digit: any,
  cpfCnpj: any
) {
  store.dispatch(getCustomersDocumentsFromApi());
  return (dispatch: any) => {
    cabine
      .get(
        `/v1/legado/clientes/documentos/${agency}/${account}/${digit}/${cpfCnpj}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(gotCustomersDocumentsFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserList);
      });
  };
}

export function getDocumentsList() {
  store.dispatch(getDocumentsListFromApi());
  return (dispatch: any) => {
    cabine
      .get(`/v1/legado/clientes/tipo/documentos`, SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(gotDocumentsListFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserList);
      });
  };
}
